module.exports = __webpack_public_path__ + "static/media/index.8c28eaf3.css";


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 24
// module chunks = 0